import React, { useState } from 'react';
import { Building2, Map, FileText, Scale, AlertCircle, TrendingUp, TrendingDown, Minus, MapPin, PlusCircle } from 'lucide-react';
import { LegalFilingsModal } from './LegalFilingsModal';
export function DetailsTab() {
  const [legalTab, setLegalTab] = useState('ALL');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedFilingIndex, setSelectedFilingIndex] = useState(0);
  const handleOpenModal = (index: number) => {
    setSelectedFilingIndex(index);
    setIsModalOpen(true);
  };
  return <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-967">
      {/* Company Details - 3 Column Layout */}
      <div className="grid grid-cols-3 gap-6" data-id="element-968">
        {/* Registration */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-4" data-id="element-969">
          <h3 className="text-sm font-bold text-gray-900 mb-3" data-id="element-970">Registration</h3>
          <div className="grid grid-cols-2 gap-y-2 gap-x-4 text-xs" data-id="element-971">
            <div data-id="element-972">
              <p className="font-semibold text-gray-900" data-id="element-973">SOS State</p>
              <p className="text-gray-600" data-id="element-974">PA</p>
            </div>
            <div data-id="element-975">
              <p className="font-semibold text-gray-900" data-id="element-976">Founded Date</p>
              <p className="text-gray-600" data-id="element-977">1949</p>
            </div>
            <div data-id="element-978">
              <p className="font-semibold text-gray-900" data-id="element-979">SOS Number</p>
              <p className="text-gray-600" data-id="element-980">8675309</p>
            </div>
            <div data-id="element-981">
              <p className="font-semibold text-gray-900" data-id="element-982">Type</p>
              <p className="text-gray-600" data-id="element-983">S-Corporation</p>
            </div>
            <div data-id="element-984">
              <p className="font-semibold text-gray-900" data-id="element-985">TIN Number</p>
              <p className="text-gray-600" data-id="element-986">23-1984726</p>
            </div>
            <div data-id="element-987">
              <p className="font-semibold text-gray-900" data-id="element-988">DBAs</p>
              <p className="text-gray-600" data-id="element-989">DUNDER MIFFLIN</p>
            </div>
            <div data-id="element-990">
              <p className="font-semibold text-gray-900" data-id="element-991">Domestic / Foreign</p>
              <p className="text-gray-600" data-id="element-992">Domestic</p>
            </div>
            <div data-id="element-993">
              <p className="font-semibold text-gray-900" data-id="element-994">Entity Type</p>
              <p className="text-gray-600" data-id="element-995">Private Subsidiary</p>
            </div>
          </div>
        </div>

        {/* Information */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-4" data-id="element-996">
          <h3 className="text-sm font-bold text-gray-900 mb-3" data-id="element-997">Information</h3>
          <div className="grid grid-cols-2 gap-y-2 gap-x-4 text-xs mb-3" data-id="element-998">
            <div data-id="element-999">
              <p className="font-semibold text-gray-900" data-id="element-1000">SIC</p>
              <p className="text-gray-600" data-id="element-1001">5112 - PAPER & OFFICE SUPPLIES</p>
            </div>
            <div data-id="element-1002">
              <p className="font-semibold text-gray-900" data-id="element-1003">Ticker</p>
              <p className="text-gray-600" data-id="element-1004">--</p>
            </div>
            <div data-id="element-1005">
              <p className="font-semibold text-gray-900" data-id="element-1006">NAICS</p>
              <p className="text-gray-600" data-id="element-1007">
                424120 - STATIONERY AND OFFICE SUPPLIES
              </p>
            </div>
            <div data-id="element-1008">
              <p className="font-semibold text-gray-900" data-id="element-1009">Approximate Revenue</p>
              <p className="text-gray-600" data-id="element-1010">~$48 Million</p>
            </div>
          </div>
          <div className="text-xs" data-id="element-1011">
            <p className="font-semibold text-gray-900 mb-0.5" data-id="element-1012">Description</p>
            <p className="text-gray-600 line-clamp-3" data-id="element-1013">
              Dunder Mifflin Inc. provides paper and office supplies to small
              businesses. With a mid-size market focus, we pride ourselves on
              customer service that big box stores can't match. "Limitless paper
              in a paperless world."
            </p>
            <button className="text-indigo-600 hover:text-indigo-700 font-medium mt-1" data-id="element-1014">
              More
            </button>
          </div>
        </div>

        {/* Location */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-4 flex flex-col" data-id="element-1015">
          <div className="flex justify-between items-start mb-2" data-id="element-1016">
            <h3 className="text-sm font-bold text-gray-900" data-id="element-1017">Location</h3>
            <Map className="w-4 h-4 text-indigo-600" data-id="element-1018" />
          </div>
          <div className="text-xs text-gray-600 mb-2" data-id="element-1019">
            <p data-id="element-1020">1725 SLOUGH AVENUE, SUITE 200</p>
            <p data-id="element-1021">SCRANTON, PA 18503, US</p>
          </div>
          <div className="flex-1 bg-gray-100 rounded-lg border border-gray-200 overflow-hidden max-h-[150px]" data-id="element-1022">
            <img src="https://cdn.magicpatterns.com/uploads/wvsUfBV1167d45Ehi9LHfe/scrantonbusinesspark2.jpg" alt="Dunder Mifflin Office - Scranton Business Park" className="w-full h-full object-contain bg-gray-50" data-id="element-1023" />
          </div>
        </div>
      </div>

      {/* Legal Filings */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-1024">
        <div className="flex items-center justify-between p-4 border-b border-gray-200 bg-gray-50/50" data-id="element-1025">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-1026">Legal Filings (4)</h3>
          <div className="flex bg-white border border-gray-200 rounded-md shadow-sm overflow-hidden text-sm font-medium" data-id="element-1027">
            {['ALL', 'LAWSUITS', 'LIENS', 'UCC', 'BANKRUPTCY'].map(tab => <button key={tab} onClick={() => setLegalTab(tab)} className={`px-4 py-2 border-r border-gray-200 last:border-r-0 flex items-center gap-2 transition-colors ${legalTab === tab ? 'bg-gray-100 text-gray-900' : 'text-gray-500 hover:bg-gray-50 hover:text-gray-700'}`} data-id="element-1028">
                {tab === 'LAWSUITS' && <Scale className="w-4 h-4" data-id="element-1029" />}
                {tab === 'LIENS' && <FileText className="w-4 h-4" data-id="element-1030" />}
                {tab === 'UCC' && <Building2 className="w-4 h-4" data-id="element-1031" />}
                {tab === 'BANKRUPTCY' && <AlertCircle className="w-4 h-4" data-id="element-1032" />}
                {tab}
              </button>)}
          </div>
        </div>

        <div className="divide-y divide-gray-100" data-id="element-1033">
          {(legalTab === 'ALL' || legalTab === 'LIENS') && <button onClick={() => handleOpenModal(0)} className="w-full p-5 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-1034">
              <div className="flex items-center gap-4" data-id="element-1035">
                <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center shrink-0" data-id="element-1036">
                  <FileText className="w-5 h-5 text-gray-500" data-id="element-1037" />
                </div>
                <div className="text-left" data-id="element-1038">
                  <div className="flex items-center gap-2 mb-0.5" data-id="element-1039">
                    <h4 className="font-bold text-gray-900" data-id="element-1040">
                      LACKAWANNA COUNTY RECORDER
                    </h4>
                    <div className="w-2 h-2 rounded-full bg-green-500" title="Released" data-id="element-1041"></div>
                  </div>
                  <p className="text-sm text-gray-500" data-id="element-1042">
                    STATE TAX LIEN • RELEASED
                  </p>
                </div>
              </div>
              <div className="text-right" data-id="element-1043">
                <p className="font-medium text-gray-900" data-id="element-1044">4/25/2016</p>
                <p className="text-sm text-gray-500" data-id="element-1045">$1,118</p>
              </div>
            </button>}

          {(legalTab === 'ALL' || legalTab === 'LAWSUITS') && <div className="p-5 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-1046">
              <div className="flex items-center gap-4" data-id="element-1047">
                <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center shrink-0" data-id="element-1048">
                  <Scale className="w-5 h-5 text-gray-500" data-id="element-1049" />
                </div>
                <div data-id="element-1050">
                  <div className="flex items-center gap-2 mb-0.5" data-id="element-1051">
                    <h4 className="font-bold text-gray-900" data-id="element-1052">
                      LEVINSON V. DUNDER MIFFLIN INC.
                    </h4>
                    <div className="w-2 h-2 rounded-full bg-yellow-500" title="Settled" data-id="element-1053"></div>
                  </div>
                  <p className="text-sm text-gray-500" data-id="element-1054">
                    CIVIL LAWSUIT • WRONGFUL TERMINATION • SETTLED
                  </p>
                </div>
              </div>
              <div className="text-right" data-id="element-1055">
                <p className="font-medium text-gray-900" data-id="element-1056">8/14/2008</p>
                <p className="text-sm text-gray-500" data-id="element-1057">Undisclosed</p>
              </div>
            </div>}

          {(legalTab === 'ALL' || legalTab === 'UCC') && <button onClick={() => handleOpenModal(1)} className="w-full p-5 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-1058">
              <div className="flex items-center gap-4" data-id="element-1059">
                <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center shrink-0" data-id="element-1060">
                  <Building2 className="w-5 h-5 text-gray-500" data-id="element-1061" />
                </div>
                <div className="text-left" data-id="element-1062">
                  <div className="flex items-center gap-2 mb-0.5" data-id="element-1063">
                    <h4 className="font-bold text-gray-900" data-id="element-1064">
                      DE LAGE LANDEN FINANCIAL SERVICES
                    </h4>
                    <div className="w-2 h-2 rounded-full bg-blue-500" title="Active" data-id="element-1065"></div>
                  </div>
                  <p className="text-sm text-gray-500" data-id="element-1066">
                    UCC FILING • EQUIPMENT LEASE (COPIERS)
                  </p>
                </div>
              </div>
              <div className="text-right" data-id="element-1067">
                <p className="font-medium text-gray-900" data-id="element-1068">2/14/2023</p>
                <p className="text-sm text-gray-500" data-id="element-1069">Active</p>
              </div>
            </button>}

          {(legalTab === 'ALL' || legalTab === 'BANKRUPTCY') && <button onClick={() => handleOpenModal(2)} className="w-full p-5 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-1070">
              <div className="flex items-center gap-4" data-id="element-1071">
                <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center shrink-0" data-id="element-1072">
                  <AlertCircle className="w-5 h-5 text-gray-500" data-id="element-1073" />
                </div>
                <div className="text-left" data-id="element-1074">
                  <div className="flex items-center gap-2 mb-0.5" data-id="element-1075">
                    <h4 className="font-bold text-gray-900" data-id="element-1076">
                      SWIDLER BERLIN SHEREFF FRIEDMAN LLP
                    </h4>
                    <div className="w-2 h-2 rounded-full bg-gray-400" title="Dismissed" data-id="element-1077"></div>
                  </div>
                  <p className="text-sm text-gray-500" data-id="element-1078">
                    CHAPTER 7 FILING (INVOLUNTARY) • DISMISSED
                  </p>
                </div>
              </div>
              <div className="text-right" data-id="element-1079">
                <p className="font-medium text-gray-900" data-id="element-1080">6/15/2019</p>
                <p className="text-sm text-gray-500" data-id="element-1081">Dismissed</p>
              </div>
            </button>}
        </div>
      </div>

      {/* News */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-1082">
        <div className="p-5 border-b border-gray-200" data-id="element-1083">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-1084">News</h3>
        </div>
        <div className="overflow-x-auto" data-id="element-1085">
          <table className="w-full text-sm text-left" data-id="element-1086">
            <thead className="bg-gray-50 text-gray-500 border-b border-gray-200" data-id="element-1087">
              <tr data-id="element-1088">
                <th className="px-5 py-3 font-medium" data-id="element-1089">Date</th>
                <th className="px-5 py-3 font-medium" data-id="element-1090">Title</th>
                <th className="px-5 py-3 font-medium" data-id="element-1091">Sentiment</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-1092">
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-1093">
                <td className="px-5 py-4 text-gray-500 whitespace-nowrap" data-id="element-1094">
                  Mar 15, 2026
                </td>
                <td className="px-5 py-4 text-gray-900 font-medium" data-id="element-1095">
                  Scranton Branch Reports Record Breaking Sales Quarter, Led by
                  Top Salesman Dwight Schrute
                </td>
                <td className="px-5 py-4" data-id="element-1096">
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-green-50 text-green-700 border border-green-200" data-id="element-1097">
                    <TrendingUp className="w-3.5 h-3.5" data-id="element-1098" />
                    Positive
                  </span>
                </td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-1099">
                <td className="px-5 py-4 text-gray-500 whitespace-nowrap" data-id="element-1100">
                  Feb 28, 2026
                </td>
                <td className="px-5 py-4 text-gray-900 font-medium" data-id="element-1101">
                  Regional Manager Hosts Unsanctioned "Office Olympics" — HR
                  Investigation Launched After Flonkerton Injury
                </td>
                <td className="px-5 py-4" data-id="element-1102">
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-red-50 text-red-700 border border-red-200" data-id="element-1103">
                    <TrendingDown className="w-3.5 h-3.5" data-id="element-1104" />
                    Negative
                  </span>
                </td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-1105">
                <td className="px-5 py-4 text-gray-500 whitespace-nowrap" data-id="element-1106">
                  Jan 12, 2026
                </td>
                <td className="px-5 py-4 text-gray-900 font-medium" data-id="element-1107">
                  Company Website 'Dunder Mifflin Infinity' Launch Plagued by
                  Social Networking Predators
                </td>
                <td className="px-5 py-4" data-id="element-1108">
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-red-50 text-red-700 border border-red-200" data-id="element-1109">
                    <TrendingDown className="w-3.5 h-3.5" data-id="element-1110" />
                    Negative
                  </span>
                </td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-1111">
                <td className="px-5 py-4 text-gray-500 whitespace-nowrap" data-id="element-1112">
                  Nov 05, 2025
                </td>
                <td className="px-5 py-4 text-gray-900 font-medium" data-id="element-1113">
                  Former Temp Arrested for Corporate Fraud, Scranton Branch
                  Manager Declares "I Knew It"
                </td>
                <td className="px-5 py-4" data-id="element-1114">
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-700 border border-gray-200" data-id="element-1115">
                    <Minus className="w-3.5 h-3.5" data-id="element-1116" />
                    Neutral
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Affiliated Companies */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-1117">
        <div className="p-5 border-b border-gray-200" data-id="element-1118">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-1119">
            Affiliated Companies
          </h3>
        </div>
        <div className="overflow-x-auto" data-id="element-1120">
          <table className="w-full text-sm text-left" data-id="element-1121">
            <thead className="bg-gray-50 text-gray-500 border-b border-gray-200" data-id="element-1122">
              <tr data-id="element-1123">
                <th className="px-5 py-3 font-medium" data-id="element-1124">Name</th>
                <th className="px-5 py-3 font-medium" data-id="element-1125">Type</th>
                <th className="px-5 py-3 font-medium" data-id="element-1126">Country</th>
                <th className="px-5 py-3 font-medium w-12" data-id="element-1127"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-1128">
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-1129">
                <td className="px-5 py-3 text-indigo-600" data-id="element-1130">ENERVATE INC.</td>
                <td className="px-5 py-3 text-gray-500" data-id="element-1131">Ultimate Parent</td>
                <td className="px-5 py-3 text-gray-500" data-id="element-1132">US</td>
                <td className="px-5 py-3" data-id="element-1133">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-50 text-green-700 border border-green-200" data-id="element-1134">
                    Monitored
                  </span>
                </td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-1135">
                <td className="px-5 py-3 text-indigo-600" data-id="element-1136">SABRE CORPORATION</td>
                <td className="px-5 py-3 text-gray-500" data-id="element-1137">Immediate Parent</td>
                <td className="px-5 py-3 text-gray-500" data-id="element-1138">US</td>
                <td className="px-5 py-3" data-id="element-1139">
                  <PlusCircle className="w-5 h-5 text-indigo-500 cursor-pointer hover:text-indigo-700 transition-colors" data-id="element-1140" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Branch Offices */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-1141">
        <div className="p-5 border-b border-gray-200" data-id="element-1142">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-1143">Branch Offices</h3>
        </div>
        <div className="overflow-x-auto" data-id="element-1144">
          <table className="w-full text-sm text-left" data-id="element-1145">
            <thead className="bg-gray-50 text-gray-500 border-b border-gray-200" data-id="element-1146">
              <tr data-id="element-1147">
                <th className="px-5 py-3 font-medium" data-id="element-1148">Name</th>
                <th className="px-5 py-3 font-medium" data-id="element-1149">Type</th>
                <th className="px-5 py-3 font-medium" data-id="element-1150">Address</th>
                <th className="px-5 py-3 font-medium" data-id="element-1151">Country</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-1152">
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-1153">
                <td className="px-5 py-3 text-gray-900" data-id="element-1154">
                  DUNDER MIFFLIN SCRANTON
                </td>
                <td className="px-5 py-3 text-gray-500" data-id="element-1155">
                  Headquarters / Branch
                </td>
                <td className="px-5 py-3 text-gray-500" data-id="element-1156">
                  1725 Slough Ave, Scranton, PA 18503
                </td>
                <td className="px-5 py-3 text-gray-500" data-id="element-1157">US</td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-1158">
                <td className="px-5 py-3 text-gray-900" data-id="element-1159">
                  DUNDER MIFFLIN AKRON
                </td>
                <td className="px-5 py-3 text-gray-500" data-id="element-1160">Branch Office</td>
                <td className="px-5 py-3 text-gray-500" data-id="element-1161">
                  400 Market St, Akron, OH 44308
                </td>
                <td className="px-5 py-3 text-gray-500" data-id="element-1162">US</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {isModalOpen && <LegalFilingsModal onClose={() => setIsModalOpen(false)} initialIndex={selectedFilingIndex} data-id="element-1163" />}
    </div>;
}